import { FormControlTableSearchableSelectAPI } from "../../../app/receipt/bill/components/formTableSelectApi/formTableSelectSearchApi";
import { MountedQuickCreate } from "./MountedQuickCreate";
import { useQuickCreateSelect } from "./useQuickCreateSelect";

/**
 * Line-table select whose first option opens a Create * drawer.
 *
 * @param {object} props
 * @param {string} props.name Formik field name.
 * @param {*} props.Drawer Quick-create drawer component.
 * @param {string} props.createLabel Dropdown create-row label.
 * @param {string=} props.context Select context, default formik.
 * @param {function(number): void=} props.onCreated Extra handler after select.
 * @return {*}
 */
export const TableQuickCreateSelect = ({
  name,
  Drawer,
  createLabel,
  context = "formik",
  onCreated,
  ...selectProps
}) => {
  const { open, setOpen, drawerProps } = useQuickCreateSelect(name, context, onCreated);

  if (!Drawer) {
    throw new Error("TableQuickCreateSelect requires a Drawer");
  }

  return (
    <>
      <FormControlTableSearchableSelectAPI
        name={name}
        context={context}
        createLabel={createLabel}
        onCreate={() => setOpen(true)}
        {...selectProps}
      />
      <MountedQuickCreate Drawer={Drawer} {...drawerProps} />
    </>
  );
};
